import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import CitiesTable from "components/Doobi/Cities";
import CountriesTable from "components/Doobi/Countries";
import NeighbourhoodTable from "components/Doobi/Neighbourhoods";

const CountriesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Countries" />
    <BrowserRouter>
    <Switch>
      <Route path={`/admin/city/:id`} component={NeighbourhoodTable}/>
      <Route path={`${match.path}/:id`} component={CitiesTable}/>
      <Route path={`${match.path}/`} component={CountriesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default CountriesRoute;
